import React, { useState } from 'react'
import ReactDOM from 'react-dom'
import './style.sass'
import { NavLink, useLocation } from 'react-router-dom'
import { useStorage64 } from '../../hooks/useStorageBase64'
import { decodeStorage } from '../../functions/storageBase64'

function ContentMenuPrincipal({ onClose }) {
    const { pathname } = useLocation()
    const [isLoged] = useStorage64('session_token', '')
    const [profileData] = useStorage64('profileData', '')
    const [telefono, setTelefono] = useStorage64('telefono_usuario', '')
    const [successVerificacion, setSuccessVerificacion] = useState(false)
    const [siredireccionar, setSiRedireccionar] = useState(false)
    const [swipe, setSwipe] = useState({ x: null, y: null })
    const hostName = window.location.origin

    const touchStart = (evt) => {
        const firstTouchEvent = evt.changedTouches[0]
        const location = {
            x: firstTouchEvent.clientX,
            y: firstTouchEvent.clientY
        }
        setSwipe(location)
        window.scrollTo(0, 0);
    }

    const touchEnd = (evt) => {
        const firstTouchEvent = evt.changedTouches[0]
        const location = {
            x: firstTouchEvent.clientX,
            y: firstTouchEvent.clientY
        }
        const final = {
            x: swipe.x - location.x,
            y: swipe.y - location.y
        }

        if (final.x >= 50) {
            onClose()
        }
    }

    const [esDark, setEsDark] = useState(false);


    return (
        <div className="moduleMenu">
            <div className="pestana"></div>
            <div className="contentMenu" onTouchStart={touchStart} onTouchEnd={touchEnd}>
                <div className="headerLogo">
                    <div className="close">
                        <button className="closeBtn" onClick={onClose}></button>
                    </div>
                    <div className="img">
                        {decodeStorage('darkMode') === true || esDark === true
                            ? <img src="/img/menuMobile/logoSearsBlanco.png" alt="logo-sears" />
                            : <img src="https://resources.sears.com.mx/medios-plazavip/swift/v1/Sears/assets/css/vector/logo-sears.svg" alt="logo-sears" />
                        }

                    </div>
                </div>

                <div className="headerModule">
                    {isLoged && profileData
                        ? <div>
                            <p>¡Hola {profileData.nombre}!</p>
                            <span>{profileData.correo}</span>
                        </div>
                        : <div>
                            <NavLink to="/login" className="goToLogin" title="Inicia Sesión o Regístrate" > Inicia sesión o Regístrate </NavLink>
                        </div>
                    }
                </div>

                <div className="contentSubSeccionMenu">
                    <div className="contSectionMenu">
                        <ul>
                            {pathname !== '/'
                                ? <li><NavLink to="/" exact className="icoInicio" title="Inicio" activeClassName="active">Inicio</NavLink></li>
                                : <li><NavLink to="/" exact className="icoInicio" onClick={onClose} title="Inicio" activeClassName="active">Inicio</NavLink></li>
                            }
                        </ul>
                    </div>

                    {isLoged
                        && <div className="contSectionMenu">
                            <ul>
                                {isLoged
                                    ? pathname !== '/mi-cuenta/mis-pedidos/'
                                        ? <li><NavLink exact to="/mi-cuenta/mis-pedidos/dias=30/pagina=1" className="icoPedidos" title="Mis pedidos" activeClassName="active">Mis Pedidos</NavLink></li>
                                        : <li><NavLink exact to="/mi-cuenta/mis-pedidos/dias=30/pagina=1" className="icoPedidos" onClick={onClose} title="Mis pedidos" activeClassName="active">Mis Pedidos</NavLink></li>
                                    : null
                                }

                                {isLoged
                                    ? pathname !== '/mi-credito/'
                                        ? <li><NavLink to="/mi-credito/" className="icoCredito" title="Mi Crédito Sears" activeClassName="active">Mi Crédito SEARS</NavLink></li>
                                        : <li><NavLink to="/mi-credito/" className="icoCredito" onClick={onClose} title="Mi Crédito Sears" activeClassName="active">Mi Crédito SEARS</NavLink></li>
                                    : null
                                }

                                {isLoged
                                    ? pathname !== '/micuenta'
                                        ? <li><NavLink exact to="/mi-cuenta" className="icoMiCuenta" title="Mi Cuenta" activeClassName="active">Mi Cuenta</NavLink></li>
                                        : <li><NavLink exact to="/mi-cuenta" className="icoMiCuenta" onClick={onClose} title="Mi Cuenta" activeClassName="active">Mi Cuenta</NavLink></li>
                                    : null
                                }

                                {isLoged
                                    ? pathname !== '/mi-cuenta/listadeseos/'
                                        ? <li><NavLink exact to="/mi-cuenta/listadeseos/" className="icoWishlist" title="Mi Lista de deseos" activeClassName="active">Mi lista de deseos</NavLink></li>
                                        : <li><NavLink exact to="/mi-cuenta/listadeseos/" className="icoWishlist" onClick={onClose} title="Mi Lista de deseos" activeClassName="active">Mi lista de deseos</NavLink></li>
                                    : null//<li><NavLink to={`/login?redirect=${hostName}/mi-cuenta/listadeseos/`} className="icoWishlist" title="Mi Lista de deseos">Mi Lista de Deseos</NavLink></li>
                                }

                            </ul>
                        </div>
                    }

                    <div className="contSectionMenu">
                        <ul>
                            {pathname !== '/categoria'
                                ? <li><NavLink to="/categoria" className="icoCategoria" title="Departamentos" activeClassName="active">Departamentos</NavLink></li>
                                : <li><NavLink to="/categoria" className="icoCategoria" onClick={onClose} title="Departamentos" activeClassName="active">Departamentos</NavLink></li>
                            }

                            {pathname !== '/localizador-tiendas'
                                ? <li><NavLink to="/localizador-tiendas" className="icoTienda" title="Encuentra tu tienda" activeClassName="active">Encuentra tu Tienda</NavLink></li>
                                : <li><NavLink to="/localizador-tiendas" className="icoTienda" onClick={onClose} title="Encuentra tu tienda" activeClassName="active">Encuentra tu tienda</NavLink></li>
                            }

                            {pathname !== '/Mesa-de-Regalos/'
                                ? <li><a href="/Mesa-de-Regalos/" className="icoMesa" title="Mesa de Regalos" activeClassName="active">Mesa de Regalos</a></li>
                                : <li><a href="/Mesa-de-Regalos/" className="icoMesa" onClick={onClose} title="Mesa de Regalos" activeClassName="active">Mesa de Regalos</a></li>
                            }

                            {pathname !== '/servicios'
                                ? <li><NavLink to="/servicios" className="icoServicios" title="Servicios" activeClassName="active">Servicios</NavLink></li>
                                : <li><NavLink to="/servicios" className="icoServicios" onClick={onClose} title="Servicios" activeClassName="active">Servicios</NavLink></li>
                            }

                        </ul>
                    </div>

                    <div className="contSectionMenu">
                        <ul>
                            {/* /testModules */}
                            <li><NavLink to="/servicios-cliente" className="icoAyuda" title="¿Necesitas ayuda?">¿Necesitas ayuda?</NavLink></li>

                        </ul>
                    </div>

                    <div className="contSectionMenu">
                        <ul>
                            <li>
                                <NavLink to="/acerca-sears" className="icoAcerca" title="Acerca de SEARS">Acerca de SEARS</NavLink>
                            </li>

                            {isLoged
                                ? pathname !== '/ajustes'
                                    ? <li><NavLink to="/ajustes" className="icoAjustes" title="Ajustes">Ajustes</NavLink></li>
                                    : <li><NavLink to="/ajustes" className="icoAjustes" onClick={onClose} title="Ajustes">Ajustes</NavLink></li>
                                : null
                            }

                        </ul>

                    </div>
                </div>

            </div>
            <div className="backgroundMenu" onClick={onClose}></div>
        </div>
    )
}

export default function MenuPrincipal({ onClose }) {
    return ReactDOM.createPortal(
        <ContentMenuPrincipal onClose={onClose} />,
        document.getElementById('modal-root')
    )
}